import * as Sentry from "@sentry/react";

const environment = process.env.REACT_APP_ENVIRONMENT || 'lcl';

if (environment !== 'lcl') {
    const dsn = process.env.REACT_APP_SENTRY_DSN;

    if (!dsn)
        throw new Error('The REACT_APP_SENTRY_DSN environment variable was not configured!');

    Sentry.init({
        dsn,
        environment
    });
}
